import React from 'react';
import ModalTemplate from "../../Wrappers/ModalTemplate";
import SpyGuy from '../../../static/images/stories/spy.svg'
import PasswordInput from "../../Atoms/Forms/PasswordInput";

const LeaveCompanyModal = () => {
  return (
    <ModalTemplate
      className="medium s-center"
    >
      <h3>¿Seguro de que quieres abandonar Discord?</h3>
      <p>No podrás acceder a la información de la empresa, sus empleados y las nóminas. Esta acción no se puede
        revertir, al menos que te vuelvan a enviar una invitación.</p>
      <img
        className="s-mb-24px"
        src={SpyGuy}
      />
      <div className="m-to-center m-60 l-block">
        <PasswordInput label="Ingresa tu contraseña para confirmar" />
      </div>
      <div className="buttons-container">
        <button className="button cancel">Cancelar</button>
        <button className="button delete"
          disabled>Abandona esta empresa
        </button>
      </div>
    </ModalTemplate>
  );
};

export default LeaveCompanyModal;
